import type { OnboardingDataDraft } from '../types/onboardingDataDraft';

export const DEFAULT_ONBOARDING_DRAFT: OnboardingDataDraft = {
  // Account data
  firstName: '',
  lastName: '',
  email: '',
  phone: '',
  dateOfBirth: '',
  birthday: '',
  terms: false,
  consent: false,
  sms: false,
  signedDocuments: [],
  userUuid: '',
  isTester: false,
  // Eligibility data
  orgKey: '',
  orgUuid: '',
  orgName: '',
  orgEligibilityCheckFields: '',
  gender: '',
  inviteCode: '',
  employeeId: '',
  insuranceId: '',
  zipCode: '',
  healthPlanUuid: '',
  selectHealthPlan: false,
  healthPlanHolderRelation: '',
  healthPlanHolderFirstName: '',
  healthPlanHolderLastName: '',
  healthPlanHolderBirthday: '',
  healthPlanHolderGender: '',
  // Profile data
  ethnicity: '',
  height: 0,
  weight: 0,
};
